import {
  inferScopeKind,
  type RoleInfoLite,
  type ScopeKind,
} from "./inferScopeKind";

type GrantLike = {
  scopeId: string;
  builtinRoleId: string | null;
  customRoleId: string | null;
};

export function countHiddenScopesOfKind(
  grants: readonly GrantLike[],
  kind: ScopeKind,
  visibleIds: ReadonlySet<string>,
  rolesMap: ReadonlyMap<string, RoleInfoLite>
): number {
  const hidden = new Set<string>();
  for (const grant of grants) {
    if (inferScopeKind(grant, rolesMap) !== kind) continue;
    if (!visibleIds.has(grant.scopeId)) hidden.add(grant.scopeId);
  }
  return hidden.size;
}
